import React from 'react';
import { Paperclip } from 'lucide-react';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { getFileIcon, formatFileSize } from './helpers';

export const Step3Confirmation = ({ formData, handleChange, files }) => (
  <div className="space-y-6">
    <div className="bg-slate-50 rounded-lg p-4">
      <h3 className="font-medium text-slate-900 mb-3">Resumo da Denúncia</h3>
      <dl className="space-y-2 text-sm">
        <div className="flex justify-between">
          <dt className="text-slate-500">Tipo:</dt>
          <dd className="font-medium">{formData.is_anonymous ? 'Anónima' : 'Identificada'}</dd>
        </div>
        <div className="flex justify-between">
          <dt className="text-slate-500">Categoria:</dt>
          <dd className="font-medium">{formData.category}</dd>
        </div>
        {formData.incident_date && (
          <div className="flex justify-between">
            <dt className="text-slate-500">Data:</dt>
            <dd className="font-medium">{formData.incident_date}</dd>
          </div>
        )}
        {formData.location && (
          <div className="flex justify-between">
            <dt className="text-slate-500">Local:</dt>
            <dd className="font-medium">{formData.location}</dd>
          </div>
        )}
      </dl>
    </div>

    <div className="bg-slate-50 rounded-lg p-4">
      <h4 className="font-medium text-slate-900 mb-2">Descrição</h4>
      <p className="text-sm text-slate-600 whitespace-pre-wrap">{formData.description}</p>
    </div>

    {files.length > 0 && (
      <div className="bg-slate-50 rounded-lg p-4">
        <h4 className="font-medium text-slate-900 mb-2">
          <Paperclip className="w-4 h-4 inline mr-2" />
          Anexos ({files.length})
        </h4>
        <ul className="space-y-1">
          {files.map((file) => (
            <li key={`${file.name}-${file.size}-${file.lastModified}`} className="text-sm text-slate-600 flex items-center gap-2">
              {getFileIcon(file.type)}
              {file.name} ({formatFileSize(file.size)})
            </li>
          ))}
        </ul>
      </div>
    )}

    <Alert className="bg-sky-50 border-sky-200">
      <AlertDescription className="text-sky-700">
        <strong>Proteção Legal:</strong> Ao abrigo da Lei 93/2021, os denunciantes de boa-fé
        estão protegidos contra represálias. A sua identidade é confidencial.
      </AlertDescription>
    </Alert>

    <div className="flex items-start space-x-3 p-4 border-2 rounded-lg border-slate-300">
      <Checkbox
        id="good_faith"
        checked={formData.good_faith_declaration}
        onCheckedChange={(v) => handleChange('good_faith_declaration', v)}
        data-testid="good-faith-checkbox"
      />
      <div>
        <Label htmlFor="good_faith" className="cursor-pointer font-medium">
          Declaração de Boa-Fé *
        </Label>
        <p className="text-sm text-slate-500 mt-1">
          Declaro que as informações fornecidas são verdadeiras e que esta denúncia é feita de boa-fé,
          com base em factos que acredito serem verídicos. Tenho conhecimento de que denúncias
          falsas podem ter consequências legais.
        </p>
      </div>
    </div>
  </div>
);
